import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30.66" {...props}><path d="M17.85 12.98L29.02 0h-2.65l-9.7 11.27L8.93 0H0l11.71 17.05L0 30.66h2.65l10.24-11.9 8.18 11.9H30L17.85 12.98zm-3.62 4.21l-1.19-1.7L3.6 1.99h4.07l7.62 10.9 1.19 1.7 9.9 14.17h-4.07L14.23 17.2z" data-name="Layer 1" /></svg>;